import React from 'react';

import { IconProps } from '../../utils/icon';

const Minus = ({ width = 20, height = 20, fill = '#fff', ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="9" width="12" height="2" rx="1" fill={fill} />
  </svg>
);

export default Minus;
